module.exports = __webpack_public_path__ + "img/08.c550cd35.jpg";